import React from 'react';

interface DataPreviewSkeletonProps {
  rows?: number;
  columns?: number;
  showHeader?: boolean;
}

const DataPreviewSkeleton: React.FC<DataPreviewSkeletonProps> = ({
  rows = 5,
  columns = 4,
  showHeader = true
}) => {
  return (
    <div className="bg-card rounded-lg shadow-sm p-6 animate-fadeIn">
      {showHeader && (
        <div className="h-5 bg-gradient-to-r from-muted via-border to-muted rounded w-1/4 mb-4 animate-pulse bg-[length:200%_100%]"></div>
      )}

      {/* Table skeleton with shimmer effect */}
      <div className="overflow-x-auto">
        <table className="min-w-full">
          <thead>
            <tr className="border-b border-border">
              {Array.from({ length: columns }).map((_, i) => (
                <th key={i} className="px-4 py-3">
                  <div
                    className="h-4 bg-gradient-to-r from-muted via-border to-muted rounded animate-shimmer bg-[length:200%_100%]"
                    style={{ animationDelay: `${i * 100}ms` }}
                  ></div>
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {Array.from({ length: rows }).map((_, row) => (
              <tr key={row} className="border-b border-border/50">
                {Array.from({ length: columns }).map((_, col) => (
                  <td key={col} className="px-4 py-3">
                    <div
                      className="h-3 bg-gradient-to-r from-muted/50 via-muted to-muted/50 rounded animate-shimmer bg-[length:200%_100%]"
                      style={{
                        animationDelay: `${(row * columns + col) * 50}ms`,
                        width: `${70 + Math.random() * 30}%`
                      }}
                    ></div>
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="mt-4 flex items-center justify-between">
        <div className="h-3 bg-gradient-to-r from-muted via-border to-muted rounded w-32 animate-shimmer bg-[length:200%_100%]"></div>
        <div className="h-3 bg-gradient-to-r from-muted via-border to-muted rounded w-24 animate-shimmer bg-[length:200%_100%]" style={{ animationDelay: '200ms' }}></div>
      </div>
    </div>
  );
};

export default DataPreviewSkeleton;